import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { PropertyListing } from "@/components";
import { favouriteWantAd, unFavouriteWantAd } from "@/services/wantAdService";
import { Link } from "react-router-dom";
import { pageURLs } from "@/constants";
import { loggedInUser } from "@/helpers/common";
import { useCurrentWebsite } from "@/hooks/useCurrentWebsite";
import "./AgentBioListings.scss";

// Crawlable "View Want-Listing" links are hidden for now; flip to true to restore them.
const SHOW_PUBLIC_VIEW_LINKS = false;

const AgentBioListings = ({ firstName, wantAds, total, onOpen }) => {
  const { isGitchaDefaultWebsite } = useCurrentWebsite();
  const isPublicVisitor = isGitchaDefaultWebsite && !loggedInUser();
  const [items, setItems] = useState(wantAds || []);
  useEffect(() => setItems(wantAds || []), [wantAds]);

  const toggleFavorite = async (isFavourite, wantAdId, clientId = []) => {
    if (!wantAdId) return;
    const adding = isFavourite == false;
    const data = { clientId: adding ? clientId : null, wantAdId };
    const response = await (adding ? favouriteWantAd(data) : unFavouriteWantAd(data)).catch(() => null);
    if (response?.errorCode !== 0) {
      toast.error("Could not update your favorites. Please try again.", { toastId: "bio-favorite-error" });
      return;
    }
    toast.success(
      adding ? "Want-Listing has been added to your favorites" : "Want-Listing has been removed from your favorites",
      { toastId: "bio-favorite-toast", autoClose: 1000 },
    );
    setItems((prev) =>
      prev.map((item) => (item.Want_ad_Id == wantAdId ? { ...item, IsFavourite: adding ? 1 : 0 } : item)),
    );
  };

  return (
    <section className="agent-bio-listings">
      <h2 className="agent-bio-section-title">
        {firstName ? `${firstName}’s Active Buyer Want‑Listings` : "Active Buyer Want‑Listings"}
        {total ? <span className="agent-bio-section-count">{total}</span> : null}
      </h2>
      {items.length ? null : (
        <p className="agent-bio-listings__empty">No active Buyer Want&#8209;Listings right&nbsp;now.</p>
      )}
      <div className="agent-bio-listings__list">
        {items.map((wantAd) => (
          <div key={wantAd.Want_ad_Id}>
            <PropertyListing
              list={wantAd}
              results={[]}
              handleFavoriteOrUnfavoriteWantAd={toggleFavorite}
              handleWantAdItemClick={(wantAdId, slug) => onOpen(slug)}
              onChangeText={() => {}}
              onAddClient={() => {}}
            />
            {SHOW_PUBLIC_VIEW_LINKS && isPublicVisitor && typeof wantAd.slug === "string" && wantAd.slug.trim() && (
              <Link
                className="agent-bio-listings__view-link"
                to={`${pageURLs.wantAdDetails}/${encodeURIComponent(wantAd.slug)}`}
                aria-label={`View Buyer Want-Listing${wantAd.Title_Text ? `: ${wantAd.Title_Text}` : ""}`}
              >
                View Want-Listing &rarr;
              </Link>
            )}
          </div>
        ))}
      </div>
    </section>
  );
};

export default AgentBioListings;
